import { isElectron } from '@web-chat-core/ui-kit/helpers/electron';
import { IN_ROOM } from 'consts';
import { selectRoomId } from 'state/selectors';

/**
 * Обрабатывает редирект пользователя после исключения из встречи
 * Удаляет флаг IN_ROOM и перенаправляет на prejoin страницу с параметром kicked=1
 * В Electron использует HashRouter для навигации на /prejoin?kicked=1
 */
export const handleKickRedirect = (): void => {
    sessionStorage.removeItem(IN_ROOM);

    if (isElectron) {
        window.location.hash = '/prejoin?kicked=1';
        return;
    }

    const roomId = selectRoomId();
    const currentPath = window.location.pathname;

    const roomNameMatch = currentPath.match(/\/(?:call\/)?([^/?]+)/);
    const roomName = roomNameMatch ? roomNameMatch[1] : '';

    const targetRoomId = roomId || roomName;

    if (targetRoomId) {
        const redirectUrl = `/${targetRoomId}?kicked=1`;
        window.location.href = redirectUrl;
    } else {
        // Если не удалось получить roomId/roomName, просто перезагружаем страницу
        console.warn('[Moderation] не удалось извлечь roomId или roomName, перезагружаем страницу');
        window.location.reload();
    }
};
